import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const IMINPOS = dynamic(() => import("../../components/hardware-partners/IMIN/IMINPOS"), {
    loading: () => <Loading />,
}
);

const MobileIMINPOS = dynamic(() => import("../../components/hardware-partners/IMIN/MobileIMINPOS"), {
    loading: () => <Loading />,
}
);

const iminPosSystem = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Imin POS Machines Compatible With QueueBuster POS Software</title>
                <meta name="description" content="Discover Imin POS hardware devices seamlessly compatible with QueueBuster POS software. Optimize your business operations with smooth integration and superior performance." />
                <link rel="canonical" href="https://queuebuster.co/pos-hardware-partners/imin" />
                <link rel="alternate" href="https://queuebuster.co/pos-hardware-partners/imin" hrefLang="en-us" />
                <meta property="og:title" content="Imin POS Hardware Devices Compatible With QueueBuster POS Software" />
                <meta property="og:description" content="Discover Imin POS hardware devices seamlessly compatible with QueueBuster POS software. Optimize your business operations with smooth integration and superior performance." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/imin.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-hardware-partners/imin" />
                
            </Head>
            {mobileView ? <MobileIMINPOS /> : <IMINPOS />}
        </>
    )
}

export default iminPosSystem